import { cusAxios, PREFIX } from './main';

const balanceGetWin2power = async (data) => {
  let response = await cusAxios(
    {
      method: 'POST',
      url: `${PREFIX}/api/adminsite/win2power_get_balance`
    },
    [603]
  );
  return response;
};

const cryptogateList = async ({ casinoId }) => {
  let response = await cusAxios(
    {
      method: 'POST',
      url: `${PREFIX}/api/adminsite/cryptogate/wallet_list`,
      data: { casinoId }
    },
    [603, 618]
  );
  return response;
};
const freespinTest = async ({ gameId, currency, fsCount, bet }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/freespins/test`,
    data: { gameId, currency, fsCount, bet }
  });
  return response;
};

const dashboardFitStat = async ({ dateFrom, dateTo, detail, currency }) => {
  let response = await cusAxios(
    {
      method: 'POST',
      url: `${PREFIX}/api/adminsite/dashboard_fin_stat`,
      data: { dateFrom, dateTo, detail, currency }
    },
    [603]
  );
  return response;
};

const dashboardCurrency = async () => {
  let response = await cusAxios(
    {
      method: 'POST',
      url: `${PREFIX}/api/adminsite/dashboard_currency_list`
    },
    [603]
  );
  return response;
};

export const API_INFO = {
  win2power: { get: balanceGetWin2power },
  cryptogate: { list: cryptogateList },
  freespinTest,
  dashboard: {
    fitStat: dashboardFitStat,
    currency: dashboardCurrency
  }
};
